import { createFileRoute } from '@tanstack/react-router'

import PageLanding from '../pages/PageLanding'

export const Route = createFileRoute('/')({
  component: PageLanding
})
